/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Question/view.blocks to change it.
import Actions from './Actions/index'
import Content from './Content/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Question({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Question.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
{children}
</React.Fragment>)
}